
@if(!permissionService()?.isUserAuthenticated()) {
    <div class="row m-3">
        <div class="col col-2 col-md-1 text-center">
            <a routerLink="/login">
                <i class="bi bi-arrow-left-square-fill text-success fs-4"></i>
            </a>
        </div>
        <div class="col"></div>
        <div class="col col-2 col-md-1 text-center">
            <a routerLink="/login">
                <i class="bi bi-arrow-left-square-fill text-success fs-4"></i>
            </a>
        </div>
    </div>
}
<div class="row m-3">
    <div class="col">
        <div class="text-primary" markdown [src]="'assets/docs/service-conditions.md'"></div>
    </div>
</div>
@if(!permissionService()?.isUserAuthenticated()) {
    <div class="row m-3">
        <div class="col col-2 col-md-1 text-center">
            <a routerLink="/login">
                <i class="bi bi-arrow-left-square-fill text-success fs-4"></i>
            </a>
        </div>
        <div class="col"></div>
        <div class="col col-2 col-md-1 text-center">
            <a routerLink="/login">
                <i class="bi bi-arrow-left-square-fill text-success fs-4"></i>
            </a>
        </div>
    </div>
}


